import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ac567ae&scoped=true"
import script from "./index.vue?vue&type=script&name=CbProductDom&lang=js"
export * from "./index.vue?vue&type=script&name=CbProductDom&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ac567ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac567ae",
  null
  
)

export default component.exports